import React, { useState, useEffect, createRef } from "react";
import { withRouter } from "react-router-dom";
import { Multiselect } from "multiselect-react-dropdown";
import Select from 'react-dropdown-select';
import moment from "moment";
import medpassService from "../services/emar-medpass-service";
import ADD_ICON from "../assets/img/add.jpg";
import DatePicker from "react-datepicker";
import { selectUsers } from "../state/reducers/userSlice";
import { connect, useSelector} from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import orderService from "../services/new-order-service";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
export function CustomSelector({
  id,
  drgList,
  setDrugList,
  handleSearch,
  obj,
  setObj,
  keyid
}) {
  const multiselectRefDrug = createRef();

  const handleDrug = (val) => {
    var test = obj;
    test[id] = val;
    setObj({ ...test });
  };
  return (
    <div key={keyid}>
      <Select
        name={id}
        options={drgList}
        labelField="drg_name"
        values={obj[id]}
        valueField="id"
        multi={false}
        searchable={true}
        onChange={(selectedList) => {
          handleDrug(selectedList);
        }}
        onClearAll={() => {
          handleDrug([]);
        }}
        searchFn={(val) => {
          if (val.state.search){
            return drgList.filter((item) => {
              return item.drg_name.toUpperCase().startsWith(val.state.search.toUpperCase())
          })
          }else{
            return drgList
          }
        }}
      />
    </div>
  );
}
const CreateStatMeds = ({ history }) => {
  const [loading, setLoading] = useState(false);
  let { user } = useSelector(selectUsers);
  const [error, setError] = useState(false);
  const [patientList, setPatientList] = useState([]);
  const [patId, setPatId] = useState([]);
  const [drgList, setDrugList] = useState([]);
  const [totalDrgList, setTotalDrugList] = useState([]);
  const [range, setRange] = useState('');
  const [rangeList, setRangeList] = useState([]);
  const [curDate, setCurDate] = useState(new Date());

  const [obj, setObj] = useState({});
  const [qtyObj, setQtyObj] = useState({});
  const [rObj, setRObj] = useState({});
  const handleSearch = async (val) => {
      setDrugList([]);
      let fList = [...totalDrgList]
      let filteredList = fList.filter((item) => item.drg_name.toUpperCase().startsWith(val.toUpperCase()));
      setDrugList([...filteredList]);
  };

  const getPatients = async (search, initial) => {
    if (search?.trim().length >= 2 || initial || search?.trim().length === 0) {
      try {
        let response = await orderService.getPatients(search);
        let pList = response?.map((item) => {
          let mname = item.mname ? item.mname : "";
          item.fname = item.lname + ', ' + item.fname + " " + mname;
          if(item?.acct_number){
            item.fname = item.fname + " ("+ item.acct_number + ")"
          }
          return item;
        });
        setPatientList([]);
        setPatientList(pList);
        if (patId?.length > 0) {
          let patSelected = pList.filter((item) => item.id === patId[0].id);
          setPatId(patSelected);
        }
      } catch (e) {
        const { hide } = cogoToast.error(
          "Error retrieving patients. Please contact administrator.",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      }
    }
  };
  const getMedications = async () => {
    try {
      if (
        patId?.length === 0 ||
        !range
      ) {
        setError(true);
        return;
      }

      const resp = await medpassService.getPatientMedications(
        moment(curDate).format("MM/DD/YYYY"),
        patId[0].id,
        [range]
      );
      setObj({});
      setQtyObj({});
      setRObj({});
      setCount([1]);
      var meds = resp?.patientMedicationViewModels?.filter((item) => item?.status === "R");
      meds.forEach((item, i) => {
        let num = count;
        if (i !== 0) {
          num.push(count.length + 1);
        }
        var test = obj;
        test[count.length] = [{ "id": item.drg_id, "drg_name": item?.drg_name }];
        setObj({ ...test });
        setCount([...num]);
      });
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting patient medication. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const getDrugList = async (fac_id) => {
    try {
      let response = await medpassService.getDrugs(fac_id);
      response.sort((a, b) => {
        const nameA = a.drg_name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.drg_name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
      
        // names must be equal
        return 0;
      });
      setDrugList([]);
      setTotalDrugList([]);
      setTotalDrugList(response);
      setDrugList(response);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error retrieving drugs. Please contact administrator.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  useEffect(() => {
    getPatients("", true);
    getDrugList(user?.facility);
    getDefaultSettings();
    return function cleanup() {
      setObj({});
    };
  }, []);

  useEffect(() => {
    if (range && patId?.length > 0) {
      getMedications();
    }
  }, [patId, range]);

  const multiselectRefPatient = createRef();
  const getDefaultSettings = async () => {
    try {
      const resp = await medpassService.getDefaults(user?.facility);
      setRangeList(resp?.ranges);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };
  const onSubmit = async () => {
    try {
      if (
        patId?.length === 0 ||
        !curDate ||
        !range
      ) {
        setError(true);
        return;
      }
      var models = [];
      for (var i = 0; i < count.length; i++) {
        if (obj[count[i]]?.[0]?.id && (qtyObj[count[i]] || rObj[count[i]])) {
          let params = {
            "range_id": range,
            "med_date": moment(curDate).format("MM/DD/YYYY"),
            "pat_id": patId[0].id,
            "drg_id": obj[count[i]]?.[0].drg_id,
            "status": rObj[count[i]] || 'P',
            "dose_taken_qty": qtyObj[count[i]]
          }
          models.push(params);
        }

      }
      if (models?.length > 0) {
        await medpassService.submitMedication({ "medPassAdminModels": models });
        setCount([1]);
        setObj({});
        setQtyObj({});
        setRObj({});
        setPatId([]);
        setRange('');
        setCurDate(new Date());
        setLoading(false);
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while submitting details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const [count, setCount] = useState([1]);
  const generateUI = () => {
    return count.map((item, i) => (

      <li key={ i} className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
        <div className="flex">
          <span className="w-2/3 mr-16">
            <label className="text-labelclr font-semibold text-sm tracking-wider">
              Drug Name
            </label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>

            <CustomSelector
              id={item}
              obj={obj}
              setObj={setObj}
              drgList={drgList}
              setDrugList={setDrugList}
              key={item}
              handleSearch={handleSearch}
            />
            {error && !obj[item]?.length && (
              <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                You must specify value
              </p>
            )}
          </span>
          <span className="w-1/3">
            <label className="text-labelclr font-semibold text-sm tracking-wider">
              Quantity
            </label>
            <span className="text-xs md:text-sm text-hlred ml-1">*</span>
            <input
              id={item}
              name={item}
              disabled={rObj[item] === 'D'}
              type="number"
              placeholder={`Enter quantity`}
              autoComplete=""
              value={qtyObj[item] || ""}
              onChange={(e) => {
                var test = qtyObj;
                test[item] = e.target.value;
                setQtyObj({ ...test });
              }}
              className={`${rObj[item] === 'D' ? 'opacity-50 cursor-not-allowed' :''}text-fogotpwsd_login placeholder-fogotpwsd_login font-semibold border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full`}
            />
            {error && !qtyObj[item] && (
              <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                You must specify value
              </p>
            )}
          </span>
          <span
            title="Refused"
            className={` mediRefused rounded-3xl text-sm border-inherit deny  cursor-pointer ${(rObj[item] === 'D') ? 'bg-mediRefused borderSelected' : 'bg-white'}`}
            onClick={(e) => {
              var test = rObj;
              if(test[item]){
                delete test[item]
              }else{
                test[item] = 'D';
                delete qtyObj[item];
              }
              setRObj({ ...test });
            }}
          >
            R
          </span>
          <span>
            <img
              id={Date.now()}
              src={ADD_ICON}
              className="mt-8 ml-3 w-6 "
              alt="ADD"
              title="ADD"
              onClick={() => {
                let num = count;
                num.push(count.length + 1);
                setCount([...num]);
              }}
            />
          </span>
        </div>
      </li>

    ));
  };
  useEffect(() => {
    generateUI()

  }, [count]);

  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"
          }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-2/3 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 h-24">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">
              ADD STATMEDS
            </span>
          </div>
        </div>
        <div className="px-12 py-5">
          <ul className="text-left">

            <li className="inline-block text-xs leading-6 w-full mb-4">
              <div className="flex">
                <span className="w-full">
                  <label className="text-labelclr w-full font-semibold text-sm tracking-wider">
                    Date
                  </label>
                  <span className="text-xs md:text-sm text-hlred ml-1  mr-8">
                    *
                  </span>
                  <div>
                    <DatePicker
                      placeholderText="MM/DD/YYYY"
                      disabled={true}
                      selected={curDate}
                      onChange={(dob) => {
                        setCurDate(dob);
                      }}
                      className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full  text-fogotpwsd_login text-sm"
                    />
                    {error && curDate === null && (
                      <p className="text-xs md:text-sm md:pt-1 text-hlred table">
                        You must specify  date
                      </p>
                    )}
                  </div>
                </span>

              </div>
            </li>
            <li className="inline-block text-xs leading-6 w-full mb-4">
              <label className="text-labelclr font-semibold text-sm tracking-wider">
                Range
              </label>
              <span className="text-xs md:text-sm text-hlred ml-1  mr-8">
                *
              </span>
              <select
                name="range"
                aria-label="Select Range"
                value={range}
                onChange={(e) => setRange(e.target.value)}
                className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
              >
                <option value="">Select Range</option>
                {rangeList
                  ? rangeList.map((pass, i) => {
                    return (
                      <option key={pass.id} value={pass.id}>
                        {pass.title}
                      </option>
                    );
                  })
                  : null}
              </select>
              {error && range?.length === 0 && (
                <p className="text-xs md:text-sm md:pt-1 text-hlred">
                  You need to specify range
                </p>
              )}
            </li>
            <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
              <span className="w-full">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Patient
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>

                {patientList ? (
                  <Select
                  name="patientList"
                  options={patientList}
                  labelField="fname"
                  values={patId}
                  valueField="id"
                  multi={false}
                  searchable={true}
                  onChange={(selectedList) => {
                    setPatId(selectedList);
                  }}
                  onClearAll={() => {
                    setPatId([]);
                  }}
                  searchFn={(val) => {
                    if (val.state.search){
                      return patientList.filter((item) => {
                        return item.fname.toUpperCase().includes(val.state.search.toUpperCase()) || (item.acct_number && item.acct_number.includes(val.state.search))
                    })
                    }else{
                      return patientList
                    }
                  }}
                />
                ) : (
                  ""
                )}

                {error && patId?.length === 0 && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    You need to specify patient
                  </p>
                )}
              </span>
            </li>

            {generateUI()}


            <li>
              <button
                className="text-white w-full h-8 px-6 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-semibold capitalize"
                onClick={() => onSubmit()}
              >
                SUBMIT
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CreateStatMeds)
);
